import { $api } from "./client";

export const useDashboardSummary = () =>
  $api.useQuery("get", "/api/v1/dashboard/summary/");

export const useStockValueHistory = () =>
  $api.useQuery("get", "/api/v1/dashboard/stock-value/");
